/**
 * Method that allocates an ArrayBuffer.
 *
 * @param {number} n
 * @return {ArrayBuffer}
 */
const malloc = (n) => new ArrayBuffer(n);
export default malloc;
